import { atom } from "jotai";
import { z } from "zod";
import { NODE_TYPES_TO_EXCLUDE_FROM_TOUR } from "@zapier/canvas-constants";
import { nodesAtom } from "@zapier/canvas-state";

import { nodeDescription, tourDescription } from "./tourContext";
import {
  tourStepSchema,
  renderAnnotationNodesSetter,
} from "./renderAnnotationNodesSetter";

import { JotaiTool } from "../../index";

export { renderAnnotationNodesSetter, nodeDescription };

export const DESCRIPTION_MIN_CHARS = 100;
export const DESCRIPTION_MAX_CHARS = 144;

const parameters = z.object({
  rawTourStepsData: z.array(tourStepSchema),
  displayMessage: z
    .string()
    .optional()
    .describe(
      "Short 3-5 word friendly message describing what you're doing, like 'Starting workflow tour...' or 'Showing canvas guide...'",
    ),
});

export const tourToolAtom = atom<JotaiTool<z.infer<typeof parameters>>>(
  (get) => {
    const nodes = get(nodesAtom);
    return {
      name: "tour",
      description: tourDescription(
        nodes,
        NODE_TYPES_TO_EXCLUDE_FROM_TOUR,
        DESCRIPTION_MIN_CHARS,
        DESCRIPTION_MAX_CHARS,
      ),
      parameters,
      execute: atom(null, async (_get, set, { args, reactFlowInstance }) => {
        const { rawTourStepsData } = args;
        set(renderAnnotationNodesSetter, {
          rawTourStepsData,
          reactFlowInstance,
        });
        return {
          content: [
            {
              type: "text",
              text: "Tour started! Use the intro panel to begin.",
            },
          ],
        };
      }),
    };
  },
);
